let collectionRows = document.querySelectorAll('.row-collection');
console.log("Archive.JSX");
collectionRows.forEach(function(item, i){
  let parentCollection = item;
  //console.log(item);
  let fullRows = item.querySelectorAll('.row');
  let rowArray = [];
  let rows = item.querySelectorAll('.row .product a');

  fullRows.forEach(function(ftem,f){
    let fullName = ftem.querySelector('.product a').innerText.trim();
    let theHandle = fullName.replace(/\s+/g, '-').toLowerCase();

    if(i == 1){
      if (theHandle == "nautilus-cigarette-box" || theHandle == "the-harvey-bracelet" || theHandle == "roberto-chain" || theHandle == "sterling-silver-coquille-box" || theHandle == "nautilus-knife" || theHandle == "harvey-bracelet" || theHandle == "quartz-coquille-box" || theHandle == "onyx-coquille-box") {
      } else {
        theHandle = theHandle + "-mens";
        //console.log(theHandle);
      }
    }

    let ajaxPath = '/products/' + theHandle + '.js';

    fetch(ajaxPath).then(function (response) {
      return response.json();
    }).then(function (data) {
      //console.log('The title of this product is ' + data.title);

      //console.log(ftem);

      ftem.addEventListener('click', function(){
        window.location.href = data.url;
      });

      let eachLink = ftem.querySelectorAll('a');
      eachLink.forEach(function(item, i){
        item.setAttribute('href', data.url);
      });
    }).catch(function (err) {
      //console.log(fullName + " does not exist.");
      let eachLink = ftem.querySelectorAll('a');
      let mailLink = "mailto:customerservice@sophiebuhai.com?subject="+ fullName+"%20-%20Archive%20Product%20Inquiry&body=Let%20us%20know%20what%20you%20would%20like%20to%20know%20regarding%20this%20product.%20Thank%20you."

      eachLink.forEach(function(item, i){
        item.setAttribute('href', mailLink);
      });

      ftem.addEventListener('click', function(){
        this.querySelectorAll('a')[0].click();
      });

    });
    
  });

  rows.forEach(function(jtem, j){
    rowArray.push([jtem.innerText, j]);
  });

  rowArray.sort(function(x,y){
    let a = x[0].toUpperCase(),
        b = y[0].toUpperCase();
    return a == b ? 0 : a > b ? 1 : -1;
  });

  //console.table(rowArray);

  let alphIndex = [];

  rowArray.forEach(function(ltem, l){
    alphIndex.push(ltem[1]);
  })

  //console.log(prizmoLink);

  // item.addEventListener('click', function(){
  //   window.open(prizmoLink);
  // })

  //console.log(alphIndex);

  alphIndex.forEach(function(mtem, m){
    //parentCollection.append(fullRows[mtem]);
  });

});